import BaseApi from './BaseApi';

class MedicalMenuApi extends BaseApi {
  delete(id: number, params?: any) {
    return this.del(`/${id}`, params);
  }

  update(id: number, params: any) {
    return this.post(`/${id}`, params);
  }

  copyMenus(params: any) {
    return this.post(`/copy`, params);
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/menus';
  }
}

export default MedicalMenuApi;
